<template>
    <div class="main">
        <c-panel :title="titulo" titleIcon="fas fa-robot">
            <painel></painel>
        </c-panel>
    </div>
</template>
<script>
import painel from "./painel"
export default {
    components: { painel },
    data () { return { titulo: '' } },
    created () { this.titulo = (this.$route.meta && this.$route.meta.title) || 'Assistente Virtual' }
}
</script>
